import React, { useEffect } from "react";
import Table from "./components/Table";
import { connect } from "react-redux";
import { fetch_Questions } from "../actions/questionActions";
import TableOptions from "./components/TableOptions";
import { Divider } from "semantic-ui-react";
import Banner from "./components/Banner";

const Home = (props) => {
  useEffect(() => {
    props.fetch_Questions();
  }, [props]);

  return (
    <div>
      <Banner />
      <Divider hidden />
      <TableOptions />
      <Divider hidden />
      <Table />
      <Divider hidden />
    </div>
  );
};

export default connect(null, { fetch_Questions })(Home);

// const all_elements = Array(...document.querySelectorAll("tr"));
// const data = all_elements.slice(6);
// const json = [];
// for (let i = 0; i < data.length; i++) {
//   try {
//     const new_entry = {
//       sno: i + 1,
//       topic: data[i].childNodes[1].innerText,
//       title: data[i].childNodes[2].innerText,
//       link: data[i].childNodes[2].firstElementChild.getAttribute("href"),
//       difficult: null,
//       completed: false,
//       favourite: false,
//     };
//     json.push(new_entry);
//   } catch (error) {}
// }
